import React from 'react'
import { Cube } from '../geometries/Cube'
import { degreesToRadians } from '../helpers'

export const Sofa = ({ position = [0, 0, 0], color = 'sienna', width = 60, height = 25, rotation = 0 }) => {
	return (
		<group position={position} rotation={[0, Math.PI / 2 - degreesToRadians(rotation), 0]} receiveShadow>
			<Cube color={color} position={[0, 1, -25]} size={[20, 2, 2]} />
			<Cube color={color} position={[0, 1, 25]} size={[20, 2, 2]} />
			<Cube color={color} position={[0, 7, 0]} size={[height, 10, width]} />
			<Cube color={color} position={[height / -2 + 5, height / 3, 0]} size={[5, height / 2, width - 10]} rotation={[0, 0, 0.2]} />
		</group>
	)
}
